import { FileGrid } from '@powerportalspro/react-fluent';
import { useMemo } from 'react';
import { ALL_FILES_VIEW_ID, getAllFilesView } from './FileUploadCustomViews';

// A FileGrid over the demo's `ppp_file` table: drop files on it to upload them into the
// `ppp_data` file column, one row each. The view shows the seed files plus the signed-in user's
// own, and the server caps how many files each user may keep.
export function FileUploadMainSample() {
  const views = useMemo(() => [getAllFilesView()], []);

  return (
    <FileGrid
      tableName="ppp_file"
      fileColumn="ppp_data"
      defaultViewId={ALL_FILES_VIEW_ID}
      viewIds={[ALL_FILES_VIEW_ID]}
      customViewDefinitions={views}
      maxHeight="500px"
      maxFileSizeBytes={512_000}
    />
  );
}
